import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useIntersectionObserver from '@salesforce/retail-react-app/app/hooks/use-intersection-observer'
import AfterPayMessage from './afterpay-message'
import KlarnaMessage from './klarna-message'
import AffirmMessage from './affirm-message'
import PayPalMessage from './paypal-message'
import useCustomerGroups from '../../../../hooks/use-customer-groups'

const UPDATE_DELAY = 300

const BNPLMessages = ({variant, product, price, customer = {}, isPreOrder = false}) => {
    const sectionRef = useRef(null)
    const shouldLoadAfterpay = useIntersectionObserver(sectionRef, {useOnce: true})
    const [displayedSelection, setDisplayedSelection] = useState({variant, product, price})

    useEffect(() => {
        if (
            displayedSelection.variant?.productId === variant?.productId &&
            displayedSelection.product?.brand === product?.brand &&
            displayedSelection.product?.c_primaryCategory === product?.c_primaryCategory &&
            displayedSelection.price === price
        ) {
            return
        }

        const timeout = setTimeout(() => {
            setDisplayedSelection({variant, product, price})
        }, UPDATE_DELAY)

        return () => clearTimeout(timeout)
    }, [displayedSelection, variant, product, price])

    const {
        variant: displayedVariant,
        product: displayedProduct,
        price: displayedPrice
    } = displayedSelection

    const {
        app: {commerceAPI}
    } = getConfig()

    const {klarna} = commerceAPI || {}
    const {configKlarna} = klarna || {}
    let klarnaEnabled = false
    try {
        if (configKlarna) {
            const jsonConfig = JSON.parse(configKlarna)
            klarnaEnabled = jsonConfig?.enablePDPCallout
        }
    } catch (e) {
        console.log(e.message)
    }
    const {data: customerGroupResp} = useCustomerGroups()
    const isEmployee =
        !!customer?.c_isEmployeeCustomer ||
        (customerGroupResp?.customerGroupIds &&
            customerGroupResp?.customerGroupIds?.indexOf('Employee') !== -1)

    return (
        <Box
            ref={sectionRef}
            backgroundColor="gray.50"
            className="bnpl-messages"
            padding="15px"
            gap="10px"
            borderRadius="5px"
            display="grid"
            sx={{
                '& p': {
                    color: 'black.100',
                    fontSize: '13px',
                    fontWeight: '300',
                    lineHeight: '22px',
                    letterSpacing: '0.065px'
                }
            }}
        >
            <AfterPayMessage
                price={displayedPrice}
                variant={displayedVariant}
                placement="secondary"
                shouldLoad={shouldLoadAfterpay}
            />
            {!isEmployee && !isPreOrder && klarnaEnabled && (
                <KlarnaMessage
                    key={`klarna-${displayedVariant?.productId}`}
                    price={displayedPrice}
                    variant={displayedVariant}
                />
            )}
            {/* order changes */}
            {klarnaEnabled ? (
                <>
                    <PayPalMessage price={displayedPrice} variantId={displayedVariant?.productId} />
                    <AffirmMessage
                        product={displayedProduct}
                        price={displayedPrice}
                        variantId={displayedVariant?.productId}
                    />
                </>
            ) : (
                <>
                    <AffirmMessage
                        product={displayedProduct}
                        price={displayedPrice}
                        variantId={displayedVariant?.productId}
                    />
                    <PayPalMessage price={displayedPrice} variantId={displayedVariant?.productId} />
                </>
            )}
        </Box>
    )
}

BNPLMessages.propTypes = {
    productId: PropTypes.any,
    variant: PropTypes.any,
    product: PropTypes.any,
    price: PropTypes.any,
    customer: PropTypes.object,
    isPreOrder: PropTypes.bool
}

export default BNPLMessages
